module.exports = __webpack_public_path__ + "img/badge-start.9ea99aaf.png";